import { getDistanceOfLocation } from './locations';
import { getPPPColorOfUser } from './trivia';

const GROUP_DISTANCE_RADIUS = 0.1;
const PIN_TO_PIN_MAX_DISTANCE_RADIUS = 0.05;

export const getEmptyUserModel = () => ({
  userId: null,
  companyName: '',
  companyValue: 0,
  companyColor: '#ffffff',
  uiLanguage: 'en',

  peoplePercentage: 0,
  planetPercentage: 0,
  profitPercentage: 0,

  kpiValues: {
    co2: 0,
    energy: 0,
    plastic: 0,
    revenue: 0,
    innovation: 0,
    customerSatisfaction: 0,
    employeeHappiness: 0,
    healthProgram: 0,
    training: 0,
  },
  kpiPercentages: {
    co2: 0,
    energy: 0,
    plastic: 0,
    revenue: 0,
    innovation: 0,
    customerSatisfaction: 0,
    employeeHappiness: 0,
    healthProgram: 0,
    training: 0,
  },
  kpiPercentagesMatrix: '',
  userLocation: {
    lat: 0,
    long: 0,
  },
});

export function getCompanyPinsFromUserData(userData) {
  return userData.reduce((companyPins, user) => {
    const id = user.userId;
    const [lat, long] = user.userLocation.split('_').map(val => parseFloat(val));

    if (
      companyPins[id] !== undefined || // pin with id already added
      (lat === '0' && long === '0') // pin has no location
    ) {
      return companyPins;
    }

    return Object.assign(companyPins, {
      [id]: {
        id,
        companyValue: parseFloat(user.companyValue),
        color: `0x${getPPPColorOfUser(user).split('#')[1]}`,
        location: { lat, long },
      },
    });
  }, {});
}

// Calculation of grouping the pins together based on a radial area
export function groupCompanyPins(companyPins) {
  const queue = { ...companyPins };

  return Object.values(companyPins).reduce((pinGroups, pin, i) => {
    // pin already added
    if (queue[pin.id] === undefined) return pinGroups;
    // search pins in radius including pin itself
    const pins = Object.values(queue).filter(comparePin => {
      if (getDistanceOfLocation(pin.location, comparePin.location) < GROUP_DISTANCE_RADIUS) {
        // delete from queue if found
        delete queue[comparePin.id];
        return true;
      }
    });

    // compare the pin set and check which pins are too close to each other
    for (let k = 0; k < pins.length; k++) {
      const actualPin = pins[k];
      const comparePins = [...pins];
      for (let j = 0; j < comparePins.length; j++) {
        if (
          getDistanceOfLocation(actualPin.location, comparePins[j].location) <
          PIN_TO_PIN_MAX_DISTANCE_RADIUS
        ) {
          pins.splice(j, 1);
        }
      }
    }

    return pinGroups.concat({
      id: `pinGroup_${i}`,
      pins,
      location: pin.location,
      color: pin.color,
    });
  }, []);
}
